import { render, staticRenderFns } from "./errorsModal.vue?vue&type=template&id=18406a5a&"
import script from "./errorsModal.vue?vue&type=script&lang=js&"
export * from "./errorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports